import { AppDispatch } from '../commons/store/store';
import { syncDirtyDamageReports } from './damageReportPersistActions';
import { persistTrainsIfNeeded } from '../trains/offline/offlineTrainsDucks';

export const syncDirtyData = () => (dispatch: AppDispatch) => {
  dispatch(persistTrainsIfNeeded());
  dispatch(syncDirtyDamageReports());
};
